export const pcPageConfig = {
  "title": "Realtime Steam Sales",
  "titleCN": "实时Steam销售",
  "path": "/realtime/sales",
  "defaultTab": "overview",
  "titleIcon": "steam",
  "timeZone": "-7",
  "tabList": [
    {
      "id": "overview",
      "tabName": "Overview",
      "tabNameCN": "总览",
      "isHaveNotification": true,
      "refresh": true,
      "refreshConfig": {
        "contentEn": "Click to refresh or auto refresh every 30 Mins.",
        "contentCn": "单击可刷新或每30分钟自动刷新一次."
      },
      "notificationPath": "/realtime/sales/overview",
      "path": "/realtime/sales/overview",
      "tabIcon": "",
      "logConfig": {
        "pageId": "205701",
        "pageName": "realtimeSteamSalesOverview",
        "extInfo": "realtimeSteamSalesOverview",
        "pagePath": "/realtime/sales/overview"
      },
      "filters": [
        {
          "name": "realtimeSteamSalesFilter",
          "isOpenSticky": false,
          "isHaveFilterSave": true,
          "filterPath": "/realtime/sales/overview",
          "componentList": [
            {
              "name": "SteamSalesService",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/realtime/sales",
                  "dataKey": "steamSales",
                  "refreshKey": "realtime_steam_sales",
                  "interval": 1800000
                }
              },
              "children": [
                {
                  "name": "SteamSalesService",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/realtime/acc_sales_units_revenue",
                      "dataKey": "steamAccSalesUnitsRevenue",
                      "refreshKey": "realtime_acc_sales_units_revenue",
                      "interval": 1800000
                    }
                  },
                  "children": [
                    {
                      "name": "SteamSalesService",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/event_analysis/realtime/date_event_list",
                          "isDark": true,
                          "dataKey": "date_event_list",
                          "refreshKey": "realtime_user_event",
                          "interval": 1800000,
                          "eventInterval": 30
                        }
                      },
                      "children": [
                        {
                          "name": "MetricsCardTitle",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "titleEn": "Realtime Key Metrics",
                              "titleCn": "实时关键指标",
                              "isMetricsExplain": true,
                              "metricsWidth": 80,
                              "data": [
                                {
                                  "titleEn": "Lifetime Gross Base Game Units",
                                  "titleCn": "历史累计本体销量",
                                  "explainEn": "Number of accumulated gross base game units sold based on Steam sales report between game launch and the end date selected.",
                                  "explainCn": "从游戏发布到所选结束日期，基于Steam平台销售报告累计售出的游戏本体数。"
                                },
                                {
                                  "titleEn": "Lifetime Gross Revenue",
                                  "titleCn": "历史累计总收入",
                                  "explainEn": "Number of accumulated gross revenue based on Steam sales report between game launch and the end date selected.",
                                  "explainCn": "从游戏发布到所选结束日期，基于Steam平台销售报告累计游戏收入。"
                                },
                                {
                                  "titleEn": "Lifetime Refund Rate",
                                  "titleCn": "历史累计退款率",
                                  "explainEn": "Lifetime Refund Rate (including dlc, bundles, etc.) from the game launch date to the end date of the statistic, Lifetime Refund Rate=Lifetime Refund Units / Lifetime Gross Units.",
                                  "explainCn": "从游戏上线之日起至统计结束日期的累计退款率（包括dlc，bundle等），累计退款率=累计退款数量/总销售数量。"
                                },
                                {
                                  "titleEn": "Gross Base Game Units",
                                  "titleCn": "本体销量",
                                  "explainEn": "The total Steam Base Game units sold on the day.",
                                  "explainCn": "当天的游戏本体 GROSS总销量"
                                },
                                {
                                  "titleEn": "Gross Revenue",
                                  "titleCn": "收入",
                                  "explainEn": "Total Steam sales amount on the day (including base unite, dlc, bundles, mtx, etc.)",
                                  "explainCn": "游戏当天所有产品（完整游戏、dlc、bundle、mtx...）在Steam售额的总和。"
                                },
                                {
                                  "titleEn": "Refund Rate",
                                  "titleCn": "退款率",
                                  "explainEn": "Steam Refund Rate on the day (including dlc, bundles, etc.) Refund Rate= Refund Units /  Gross Units",
                                  "explainCn": "游戏当天的Steam退款率（包括dlc，bundle等）。退款率=当天退款数量/当天销售数量。"
                                }
                              ]
                            }
                          }
                        },
                        {
                          "name": "CardContext",
                          "children": [
                            {
                              "name": "CommonRow",
                              "className": "dbd-realtime-card-hide-dod",
                              "type": "layout",
                              "style": {
                                "marginBottom": "10px"
                              },
                              "props": {},
                              "children": [
                                {
                                  "name": "CommonCol",
                                  "className": "",
                                  "type": "layout",
                                  "style": {},
                                  "props": {
                                    "w": 8
                                  },
                                  "children": [
                                    {
                                      "name": "SteamSalesCard",
                                      "className": "",
                                      "type": "view",
                                      "style": {},
                                      "props": {
                                        "dataKey": [
                                          "lifetime_gross_full_game_units"
                                        ],
                                        "apiDataKey": [
                                          "steamAccSalesUnitsRevenue"
                                        ],
                                        "config": {
                                          "titleIcon": "steam",
                                          "titleEn": "Lifetime Gross Base Game Units",
                                          "titleCn": "历史累计本体销量",
                                          "formatRule": "thousandsInit",
                                          "dateFormat": "YYYY-MM-DD HH:mm",
                                          "dodData": [
                                            {
                                              "titleEn": "DOD",
                                              "titleCn": "日环比",
                                              "formatRule": "absPercent1Decimal",
                                              "extendFormatRule": "thousandsInit"
                                            },
                                            {
                                              "titleEn": "SDLW",
                                              "titleCn": "上周同期",
                                              "formatRule": "absPercent1Decimal",
                                              "extendFormatRule": "thousandsInit"
                                            }
                                          ],
                                          "rainbowKey": "Pc Est. Lifetime Steam Gross Base Game Units"
                                        }
                                      }
                                    }
                                  ]
                                },
                                {
                                  "name": "CommonCol",
                                  "className": "",
                                  "type": "layout",
                                  "style": {},
                                  "props": {
                                    "w": 8
                                  },
                                  "children": [
                                    {
                                      "name": "SteamSalesCard",
                                      "className": "",
                                      "type": "view",
                                      "style": {},
                                      "props": {
                                        "dataKey": [
                                          "lifetime_gross_revenue"
                                        ],
                                        "apiDataKey": [
                                          "steamAccSalesUnitsRevenue"
                                        ],
                                        "config": {
                                          "titleIcon": "steam",
                                          "titleEn": "Lifetime Gross Revenue",
                                          "titleCn": "历史累计总收入",
                                          "formatRule": "thousands2Decimal",
                                          "dateFormat": "YYYY-MM-DD HH:mm",
                                          "preUnit": "$",
                                          "dodData": [
                                            {
                                              "titleEn": "DOD",
                                              "titleCn": "日环比",
                                              "formatRule": "absPercent1Decimal",
                                              "extendFormatRule": "thousands2Decimal"
                                            },
                                            {
                                              "titleEn": "SDLW",
                                              "titleCn": "上周同期",
                                              "formatRule": "absPercent1Decimal",
                                              "extendFormatRule": "thousands2Decimal"
                                            }
                                          ],
                                          "rainbowKey": "Pc Est. Lifetime Steam Gross Revenue"
                                        }
                                      }
                                    }
                                  ]
                                },
                                {
                                  "name": "CommonCol",
                                  "className": "",
                                  "type": "layout",
                                  "style": {},
                                  "props": {
                                    "w": 8
                                  },
                                  "children": [
                                    {
                                      "name": "SteamSalesCard",
                                      "className": "",
                                      "type": "view",
                                      "style": {},
                                      "props": {
                                        "dataKey": [
                                          "lifetime_refund_rate"
                                        ],
                                        "apiDataKey": [
                                          "steamAccSalesUnitsRevenue"
                                        ],
                                        "config": {
                                          "titleIcon": "steam",
                                          "titleEn": "Lifetime Refund Rate",
                                          "titleCn": "历史累计退款率",
                                          "formatRule": "percent2Decimal",
                                          "dateFormat": "YYYY-MM-DD HH:mm",
                                          "dodData": [
                                            {
                                              "titleEn": "DOD",
                                              "titleCn": "日环比",
                                              "formatRule": "absPercent1Decimal",
                                              "extendFormatRule": "percent2Decimal"
                                            },
                                            {
                                              "titleEn": "SDLW",
                                              "titleCn": "上周同期",
                                              "formatRule": "absPercent1Decimal",
                                              "extendFormatRule": "percent2Decimal"
                                            }
                                          ],
                                          "rainbowKey": "Pc Est. Lifetime Steam Refund Rate"
                                        }
                                      }
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "name": "CommonRow",
                              "className": "",
                              "type": "layout",
                              "style": {},
                              "props": {},
                              "children": [
                                {
                                  "name": "CommonCol",
                                  "className": "",
                                  "type": "layout",
                                  "style": {},
                                  "props": {
                                    "w": 8
                                  },
                                  "children": [
                                    {
                                      "name": "SteamSalesCard",
                                      "className": "",
                                      "type": "view",
                                      "style": {},
                                      "props": {
                                        "dataKey": [
                                          "gross_full_game_units_card"
                                        ],
                                        "apiDataKey": [
                                          "steamSales"
                                        ],
                                        "config": {
                                          "titleIcon": "steam",
                                          "titleEn": "Gross Base Game Units",
                                          "titleCn": "本体销量",
                                          "formatRule": "thousandsInit",
                                          "dodData": [
                                            {
                                              "titleEn": "DOD",
                                              "titleCn": "日环比",
                                              "formatRule": "absPercent1Decimal",
                                              "extendFormatRule": "thousandsInit"
                                            },
                                            {
                                              "titleEn": "SDLW",
                                              "titleCn": "上周同期",
                                              "formatRule": "absPercent1Decimal",
                                              "extendFormatRule": "thousandsInit"
                                            }
                                          ],
                                          "rainbowKey": "Pc Steam Gross Base Game Units"
                                        }
                                      }
                                    }
                                  ]
                                },
                                {
                                  "name": "CommonCol",
                                  "className": "",
                                  "type": "layout",
                                  "style": {},
                                  "props": {
                                    "w": 8
                                  },
                                  "children": [
                                    {
                                      "name": "SteamSalesCard",
                                      "className": "",
                                      "type": "view",
                                      "style": {},
                                      "props": {
                                        "dataKey": [
                                          "gross_revenue_card"
                                        ],
                                        "apiDataKey": [
                                          "steamSales"
                                        ],
                                        "config": {
                                          "titleIcon": "steam",
                                          "titleEn": "Gross Revenue",
                                          "titleCn": "收入",
                                          "formatRule": "thousands2Decimal",
                                          "preUnit": "$",
                                          "dodData": [
                                            {
                                              "titleEn": "DOD",
                                              "titleCn": "日环比",
                                              "formatRule": "absPercent1Decimal",
                                              "extendFormatRule": "thousands2Decimal"
                                            },
                                            {
                                              "titleEn": "SDLW",
                                              "titleCn": "上周同期",
                                              "formatRule": "absPercent1Decimal",
                                              "extendFormatRule": "thousands2Decimal"
                                            }
                                          ],
                                          "rainbowKey": "Pc Steam Gross Revenue"
                                        }
                                      }
                                    }
                                  ]
                                },
                                {
                                  "name": "CommonCol",
                                  "className": "",
                                  "type": "layout",
                                  "style": {},
                                  "props": {
                                    "w": 8
                                  },
                                  "children": [
                                    {
                                      "name": "SteamSalesCard",
                                      "className": "",
                                      "type": "view",
                                      "style": {},
                                      "props": {
                                        "dataKey": [
                                          "refund_rate_card"
                                        ],
                                        "apiDataKey": [
                                          "steamSales"
                                        ],
                                        "config": {
                                          "titleIcon": "steam",
                                          "titleEn": "Refund Rate",
                                          "titleCn": "退款率",
                                          "formatRule": "percent2Decimal",
                                          "dodData": [
                                            {
                                              "titleEn": "DOD",
                                              "titleCn": "日环比",
                                              "formatRule": "absPercent1Decimal",
                                              "extendFormatRule": "percent2Decimal"
                                            },
                                            {
                                              "titleEn": "SDLW",
                                              "titleCn": "上周同期",
                                              "formatRule": "absPercent1Decimal",
                                              "extendFormatRule": "percent2Decimal"
                                            }
                                          ],
                                          "rainbowKey": "Pc Steam Refund Rate"
                                        }
                                      }
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "name": "SegmentScrollCo",
                          "className": "margin-t-20",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentSegment": [
                                {
                                  "value": "1",
                                  "enName": "Gross Base Game Units",
                                  "cnName": "本体销量",
                                  "disable": false,
                                  "rainbowKey": "",
                                  "enTooltip": "",
                                  "cntooltip": ""
                                },
                                {
                                  "value": "2",
                                  "enName": "Gross Revenue",
                                  "cnName": "收入",
                                  "disable": false,
                                  "rainbowKey": "",
                                  "enTooltip": "",
                                  "cntooltip": ""
                                },
                                {
                                  "value": "3",
                                  "enName": "Refund Rate",
                                  "cnName": "退款率",
                                  "rainbowKey": "",
                                  "disable": false,
                                  "enTooltip": "",
                                  "cntooltip": ""
                                },
                                {
                                  "value": "4",
                                  "enName": "Base Game Units After Refund",
                                  "cnName": "本体销量(剔除退款)",
                                  "rainbowKey": "",
                                  "disable": false,
                                  "enTooltip": "",
                                  "cntooltip": ""
                                },
                                {
                                  "value": "5",
                                  "enName": "Revenue After Refund & Tax",
                                  "cnName": "收入(剔除退款&税收)",
                                  "rainbowKey": "",
                                  "disable": false,
                                  "enTooltip": "",
                                  "cntooltip": ""
                                },
                                {
                                  "value": "6",
                                  "enName": "Revenue After Refund",
                                  "cnName": "收入(剔除退款)",
                                  "rainbowKey": "",
                                  "disable": false,
                                  "enTooltip": "",
                                  "cntooltip": ""
                                }
                              ],
                              "scrollMarginTop": "75px"
                            }
                          },
                          "children": [
                            {
                              "name": "RealtimeRentationContext",
                              "props": {
                                "config": {
                                  "preTitleIcon": "steam",
                                  "title": "Realtime Daily Accum Gross Base Game Units (30Mins)",
                                  "titleCn": "每日实时累计销量 (30分钟)",
                                  "explain": "Statistical Time: {{lastUpdateTime|string}}",
                                  "explainCn": "统计时间: {{lastUpdateTime|string}}",
                                  "apiDataKey": "steamSales",
                                  "dataKey": "gross_full_game_units",
                                  "dataType": "",
                                  "table": {
                                    "option": [
                                      {
                                        "key": "time",
                                        "align": "left",
                                        "fixed": "left",
                                        "width": 100,
                                        "title": "Time",
                                        "titleCn": "时间",
                                        "formatTitle": "realtime_by_country_table_time",
                                        "valueKey": "time"
                                      },
                                      {
                                        "key": "line_dot",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                        "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}",
                                        "valueKey": "lineDot",
                                        "format": "#,##0",
                                        "type": "number"
                                      },
                                      {
                                        "key": "line_dot_last",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "valueKey": "lineDotLast",
                                        "format": "#,##0",
                                        "type": "number"
                                      },
                                      {
                                        "key": "line_dot_contrast",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day",
                                        "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日",
                                        "valueKey": "lineDotContrast",
                                        "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                        "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}",
                                        "format": "#,##0",
                                        "type": "number"
                                      }
                                    ],
                                    "sort": true,
                                    "columns": [
                                      "time"
                                    ],
                                    "defaultValue": [
                                      {
                                        "by": "time",
                                        "order": "desc"
                                      }
                                    ],
                                    "isRealTime": true,
                                    "height": 400
                                  },
                                  "subTitle": [
                                    {
                                      "title": "DoD",
                                      "titleCn": "日环比",
                                      "formatTitle": "",
                                      "valueKey": "dod",
                                      "unit": "percent",
                                      "bold": true
                                    },
                                    {
                                      "title": "SDLW",
                                      "titleCn": "上周同期",
                                      "formatTitle": "",
                                      "valueKey": "sdlw",
                                      "unit": "percent",
                                      "bold": true
                                    }
                                  ],
                                  "event": {
                                    "show": true,
                                    "link": "eventAnalysis/eventDetails",
                                    "dataKey": "date_event_list",
                                    "valueKey": "event",
                                    "timeType": "Hour",
                                    "cssStyle": {
                                      "top": "82%"
                                    }
                                  },
                                  "chart": {
                                    "type": "line",
                                    "series": [
                                      {
                                        "valueKey": "line_dot",
                                        "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                        "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}"
                                      },
                                      {
                                        "valueKey": "line_dot_last",
                                        "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}"
                                      },
                                      {
                                        "valueKey": "line_dot_contrast",
                                        "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day)",
                                        "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日)",
                                        "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                        "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}"
                                      }
                                    ],
                                    "tooltip": {
                                      "title": "Gross Base Game Units",
                                      "titleCn": "本体销量"
                                    }
                                  }
                                }
                              },
                              "id": 1
                            },
                            {
                              "name": "RealtimeRentationContext",
                              "props": {
                                "config": {
                                  "preTitleIcon": "steam",
                                  "title": "Realtime Daily Accum Gross Revenue (30Mins)",
                                  "titleCn": "每日实时累计收入 (30分钟)",
                                  "explain": "Statistical Time: {{lastUpdateTime|string}}",
                                  "explainCn": "统计时间: {{lastUpdateTime|string}}",
                                  "apiDataKey": "steamSales",
                                  "dataKey": "gross_revenue",
                                  "dataType": "money",
                                  "currencyUnit": "$",
                                  "table": {
                                    "option": [
                                      {
                                        "key": "time",
                                        "align": "left",
                                        "fixed": "left",
                                        "width": 100,
                                        "title": "Time",
                                        "titleCn": "时间",
                                        "formatTitle": "realtime_by_country_table_time",
                                        "valueKey": "time"
                                      },
                                      {
                                        "key": "line_dot",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                        "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}",
                                        "valueKey": "lineDot",
                                        "format": "#,##0.00",
                                        "type": "number"
                                      },
                                      {
                                        "key": "line_dot_last",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "valueKey": "lineDotLast",
                                        "format": "#,##0.00",
                                        "type": "number"
                                      },
                                      {
                                        "key": "line_dot_contrast",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day",
                                        "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日",
                                        "valueKey": "lineDotContrast",
                                        "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                        "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}",
                                        "format": "#,##0.00",
                                        "type": "number"
                                      }
                                    ],
                                    "sort": true,
                                    "columns": [
                                      "time"
                                    ],
                                    "defaultValue": [
                                      {
                                        "by": "time",
                                        "order": "desc"
                                      }
                                    ],
                                    "isRealTime": true,
                                    "height": 400
                                  },
                                  "subTitle": [
                                    {
                                      "title": "DoD",
                                      "titleCn": "日环比",
                                      "formatTitle": "",
                                      "valueKey": "dod",
                                      "unit": "percent",
                                      "bold": true
                                    },
                                    {
                                      "title": "SDLW",
                                      "titleCn": "上周同期",
                                      "formatTitle": "",
                                      "valueKey": "sdlw",
                                      "unit": "percent",
                                      "bold": true
                                    }
                                  ],
                                  "event": {
                                    "show": true,
                                    "link": "eventAnalysis/eventDetails",
                                    "dataKey": "date_event_list",
                                    "valueKey": "event",
                                    "timeType": "Hour",
                                    "cssStyle": {
                                      "top": "82%"
                                    }
                                  },
                                  "chart": {
                                    "type": "line",
                                    "series": [
                                      {
                                        "valueKey": "line_dot",
                                        "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                        "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}"
                                      },
                                      {
                                        "valueKey": "line_dot_last",
                                        "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}"
                                      },
                                      {
                                        "valueKey": "line_dot_contrast",
                                        "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day)",
                                        "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日)",
                                        "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                        "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}"
                                      }
                                    ],
                                    "tooltip": {
                                      "title": "Gross Revenue",
                                      "titleCn": "收入"
                                    }
                                  }
                                }
                              },
                              "id": 2
                            },
                            {
                              "name": "RealtimeRentationContext",
                              "props": {
                                "config": {
                                  "preTitleIcon": "steam",
                                  "title": "Realtime Daily Accum Refund Rate (30Mins)",
                                  "titleCn": "每日实时累计退款率 (30分钟)",
                                  "explain": "Statistical Time: {{lastUpdateTime|string}}",
                                  "explainCn": "统计时间: {{lastUpdateTime|string}}",
                                  "apiDataKey": "steamSales",
                                  "dataKey": "refund_rate",
                                  "dataType": "percent",
                                  "table": {
                                    "option": [
                                      {
                                        "key": "time",
                                        "align": "left",
                                        "fixed": "left",
                                        "width": 100,
                                        "title": "Time",
                                        "titleCn": "时间",
                                        "formatTitle": "realtime_by_country_table_time",
                                        "valueKey": "time"
                                      },
                                      {
                                        "key": "line_dot",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                        "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}",
                                        "valueKey": "lineDot",
                                        "format": "##,##0.00%",
                                        "type": "percent"
                                      },
                                      {
                                        "key": "line_dot_last",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "valueKey": "lineDotLast",
                                        "format": "##,##0.00%",
                                        "type": "percent"
                                      },
                                      {
                                        "key": "line_dot_contrast",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day",
                                        "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日",
                                        "valueKey": "lineDotContrast",
                                        "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                        "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}",
                                        "format": "##,##0.00%",
                                        "type": "percent"
                                      }
                                    ],
                                    "sort": true,
                                    "columns": [
                                      "time"
                                    ],
                                    "defaultValue": [
                                      {
                                        "by": "time",
                                        "order": "desc"
                                      }
                                    ],
                                    "isRealTime": true,
                                    "height": 400
                                  },
                                  "subTitle": [
                                    {
                                      "title": "DoD",
                                      "titleCn": "日环比",
                                      "formatTitle": "",
                                      "valueKey": "dod",
                                      "unit": "percent",
                                      "bold": true
                                    },
                                    {
                                      "title": "SDLW",
                                      "titleCn": "上周同期",
                                      "formatTitle": "",
                                      "valueKey": "sdlw",
                                      "unit": "percent",
                                      "bold": true
                                    }
                                  ],
                                  "event": {
                                    "show": true,
                                    "link": "eventAnalysis/eventDetails",
                                    "dataKey": "date_event_list",
                                    "valueKey": "event",
                                    "timeType": "Hour",
                                    "cssStyle": {
                                      "top": "82%"
                                    }
                                  },
                                  "chart": {
                                    "type": "line",
                                    "series": [
                                      {
                                        "valueKey": "line_dot",
                                        "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                        "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}"
                                      },
                                      {
                                        "valueKey": "line_dot_last",
                                        "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}"
                                      },
                                      {
                                        "valueKey": "line_dot_contrast",
                                        "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day)",
                                        "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日)",
                                        "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                        "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}"
                                      }
                                    ],
                                    "tooltip": {
                                      "title": "Refund Rate",
                                      "titleCn": "退款率"
                                    }
                                  }
                                }
                              },
                              "id": 3
                            },
                            {
                              "name": "RealtimeRentationContext",
                              "props": {
                                "config": {
                                  "preTitleIcon": "steam",
                                  "title": "Realtime Daily Accum Base Game Units After Refund (30Mins)",
                                  "titleCn": "每日实时累计销量(剔除退款) (30分钟)",
                                  "explain": "Statistical Time: {{lastUpdateTime|string}}",
                                  "explainCn": "统计时间: {{lastUpdateTime|string}}",
                                  "apiDataKey": "steamSales",
                                  "dataKey": "net_full_game_units",
                                  "dataType": "",
                                  "table": {
                                    "option": [
                                      {
                                        "key": "time",
                                        "align": "left",
                                        "fixed": "left",
                                        "width": 100,
                                        "title": "Time",
                                        "titleCn": "时间",
                                        "formatTitle": "realtime_by_country_table_time",
                                        "valueKey": "time"
                                      },
                                      {
                                        "key": "line_dot",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                        "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}",
                                        "valueKey": "lineDot",
                                        "format": "#,##0",
                                        "type": "number"
                                      },
                                      {
                                        "key": "line_dot_last",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "valueKey": "lineDotLast",
                                        "format": "#,##0",
                                        "type": "number"
                                      },
                                      {
                                        "key": "line_dot_contrast",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day",
                                        "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日",
                                        "valueKey": "lineDotContrast",
                                        "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                        "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}",
                                        "format": "#,##0",
                                        "type": "number"
                                      }
                                    ],
                                    "sort": true,
                                    "columns": [
                                      "time"
                                    ],
                                    "defaultValue": [
                                      {
                                        "by": "time",
                                        "order": "desc"
                                      }
                                    ],
                                    "isRealTime": true,
                                    "height": 400
                                  },
                                  "subTitle": [
                                    {
                                      "title": "DoD",
                                      "titleCn": "日环比",
                                      "formatTitle": "",
                                      "valueKey": "dod",
                                      "unit": "percent",
                                      "bold": true
                                    },
                                    {
                                      "title": "SDLW",
                                      "titleCn": "上周同期",
                                      "formatTitle": "",
                                      "valueKey": "sdlw",
                                      "unit": "percent",
                                      "bold": true
                                    }
                                  ],
                                  "event": {
                                    "show": true,
                                    "link": "eventAnalysis/eventDetails",
                                    "dataKey": "date_event_list",
                                    "valueKey": "event",
                                    "timeType": "Hour",
                                    "cssStyle": {
                                      "top": "82%"
                                    }
                                  },
                                  "chart": {
                                    "type": "line",
                                    "series": [
                                      {
                                        "valueKey": "line_dot",
                                        "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                        "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}"
                                      },
                                      {
                                        "valueKey": "line_dot_last",
                                        "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}"
                                      },
                                      {
                                        "valueKey": "line_dot_contrast",
                                        "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day)",
                                        "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日)",
                                        "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                        "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}"
                                      }
                                    ],
                                    "tooltip": {
                                      "title": "Base Game Units After Refund",
                                      "titleCn": "本体销量(剔除退款)"
                                    }
                                  }
                                }
                              },
                              "id": 4
                            },
                            {
                              "name": "RealtimeRentationContext",
                              "props": {
                                "config": {
                                  "preTitleIcon": "steam",
                                  "title": "Realtime Daily Accum Revenue After Refund & Tax (30Mins)",
                                  "titleCn": "每日实时累计收入(剔除退款&税收) (30分钟)",
                                  "explain": "Statistical Time: {{lastUpdateTime|string}}",
                                  "explainCn": "统计时间: {{lastUpdateTime|string}}",
                                  "apiDataKey": "steamSales",
                                  "dataKey": "net_revenue",
                                  "dataType": "money",
                                  "currencyUnit": "$",
                                  "table": {
                                    "option": [
                                      {
                                        "key": "time",
                                        "align": "left",
                                        "fixed": "left",
                                        "width": 100,
                                        "title": "Time",
                                        "titleCn": "时间",
                                        "formatTitle": "realtime_by_country_table_time",
                                        "valueKey": "time"
                                      },
                                      {
                                        "key": "line_dot",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                        "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}",
                                        "valueKey": "lineDot",
                                        "format": "#,##0.00",
                                        "type": "number"
                                      },
                                      {
                                        "key": "line_dot_last",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "valueKey": "lineDotLast",
                                        "format": "#,##0.00",
                                        "type": "number"
                                      },
                                      {
                                        "key": "line_dot_contrast",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day",
                                        "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日",
                                        "valueKey": "lineDotContrast",
                                        "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                        "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}",
                                        "format": "#,##0.00",
                                        "type": "number"
                                      }
                                    ],
                                    "sort": true,
                                    "columns": [
                                      "time"
                                    ],
                                    "defaultValue": [
                                      {
                                        "by": "time",
                                        "order": "desc"
                                      }
                                    ],
                                    "isRealTime": true,
                                    "height": 400
                                  },
                                  "subTitle": [
                                    {
                                      "title": "DoD",
                                      "titleCn": "日环比",
                                      "formatTitle": "",
                                      "valueKey": "dod",
                                      "unit": "percent",
                                      "bold": true
                                    },
                                    {
                                      "title": "SDLW",
                                      "titleCn": "上周同期",
                                      "formatTitle": "",
                                      "valueKey": "sdlw",
                                      "unit": "percent",
                                      "bold": true
                                    }
                                  ],
                                  "event": {
                                    "show": true,
                                    "link": "eventAnalysis/eventDetails",
                                    "dataKey": "date_event_list",
                                    "valueKey": "event",
                                    "timeType": "Hour",
                                    "cssStyle": {
                                      "top": "82%"
                                    }
                                  },
                                  "chart": {
                                    "type": "line",
                                    "series": [
                                      {
                                        "valueKey": "line_dot",
                                        "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                        "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}"
                                      },
                                      {
                                        "valueKey": "line_dot_last",
                                        "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}"
                                      },
                                      {
                                        "valueKey": "line_dot_contrast",
                                        "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day)",
                                        "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日)",
                                        "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                        "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}"
                                      }
                                    ],
                                    "tooltip": {
                                      "title": "Revenue After Refund & Tax",
                                      "titleCn": "收入(剔除退款&税收)"
                                    }
                                  }
                                }
                              },
                              "id": 5
                            },
                            {
                              "name": "RealtimeRentationContext",
                              "props": {
                                "config": {
                                  "preTitleIcon": "steam",
                                  "title": "Realtime Daily Accum Revenue After Refund (30Mins)",
                                  "titleCn": "每日实时累计收入(剔除退款) (30分钟)",
                                  "explain": "Statistical Time: {{lastUpdateTime|string}}",
                                  "explainCn": "统计时间: {{lastUpdateTime|string}}",
                                  "apiDataKey": "steamSales",
                                  "dataKey": "gross_refund_after_revenue",
                                  "dataType": "money",
                                  "currencyUnit": "$",
                                  "table": {
                                    "option": [
                                      {
                                        "key": "time",
                                        "align": "left",
                                        "fixed": "left",
                                        "width": 100,
                                        "title": "Time",
                                        "titleCn": "时间",
                                        "formatTitle": "realtime_by_country_table_time",
                                        "valueKey": "time"
                                      },
                                      {
                                        "key": "line_dot",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                        "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}",
                                        "valueKey": "lineDot",
                                        "format": "#,##0.00",
                                        "type": "number"
                                      },
                                      {
                                        "key": "line_dot_last",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "valueKey": "lineDotLast",
                                        "format": "#,##0.00",
                                        "type": "number"
                                      },
                                      {
                                        "key": "line_dot_contrast",
                                        "align": "right",
                                        "fixed": "",
                                        "width": 100,
                                        "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day",
                                        "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日",
                                        "valueKey": "lineDotContrast",
                                        "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                        "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}",
                                        "format": "#,##0.00",
                                        "type": "number"
                                      }
                                    ],
                                    "sort": true,
                                    "columns": [
                                      "time"
                                    ],
                                    "defaultValue": [
                                      {
                                        "by": "time",
                                        "order": "desc"
                                      }
                                    ],
                                    "isRealTime": true,
                                    "height": 400
                                  },
                                  "subTitle": [
                                    {
                                      "title": "DoD",
                                      "titleCn": "日环比",
                                      "formatTitle": "",
                                      "valueKey": "dod",
                                      "unit": "percent",
                                      "bold": true
                                    },
                                    {
                                      "title": "SDLW",
                                      "titleCn": "上周同期",
                                      "formatTitle": "",
                                      "valueKey": "sdlw",
                                      "unit": "percent",
                                      "bold": true
                                    }
                                  ],
                                  "event": {
                                    "show": true,
                                    "link": "eventAnalysis/eventDetails",
                                    "dataKey": "date_event_list",
                                    "valueKey": "event",
                                    "timeType": "Hour",
                                    "cssStyle": {
                                      "top": "82%"
                                    }
                                  },
                                  "chart": {
                                    "type": "line",
                                    "series": [
                                      {
                                        "valueKey": "line_dot",
                                        "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                        "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}"
                                      },
                                      {
                                        "valueKey": "line_dot_last",
                                        "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                        "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}"
                                      },
                                      {
                                        "valueKey": "line_dot_contrast",
                                        "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day)",
                                        "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日)",
                                        "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                        "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}"
                                      }
                                    ],
                                    "tooltip": {
                                      "title": "Revenue After Refund",
                                      "titleCn": "收入(剔除退款)"
                                    }
                                  }
                                }
                              },
                              "id": 6
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "byCountryRegion",
      "tabName": "By Platform/Region/Country",
      "tabNameCN": "分平台/区域/国家",
      "isHaveNotification": true,
      "refresh": true,
      "notificationPath": "/realtime/sales/byCountryRegion",
      "path": "/realtime/sales/byCountryRegion",
      "tabIcon": "",
      "logConfig": {
        "pageId": "205702",
        "pageName": "realtimeSalesByCountryRegion",
        "extInfo": "realtimeSalesByCountryRegion",
        "pagePath": "/realtime/sales/byCountryRegion"
      },
      "filters": [
        {
          "name": "realtimeSteamSalesCountryFilter",
          "isOpenSticky": false,
          "isHaveFilterSave": true,
          "filterPath": "/realtime/sales/byCountryRegion",
          "timeZone": "-8",
          "componentList": [
            {
              "name": "SteamSalesService",
              "className": "dbd-realtime-sales-trend",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/realtime/dimension/sales",
                  "dataKey": "dimension_sales",
                  "refreshKey": "realtime_steam_country",
                  "interval": 1800000
                }
              },
              "data": {
                "dataBy": "country"
              },
              "children": [
                {
                  "name": "ScrollBodyCo",
                  "className": "margin-t-20",
                  "style": {},
                  "type": "view",
                  "props": {
                    "config": {
                      "dataKey": "dataBy",
                      "componentSegment": [
                        {
                          "value": "1",
                          "enName": "Gross Base Game Units",
                          "cnName": "本体销量",
                          "disable": false,
                          "rainbowKey": "",
                          "enTooltip": "",
                          "cntooltip": ""
                        },
                        {
                          "value": "2",
                          "enName": "Gross Revenue",
                          "cnName": "收入",
                          "disable": false,
                          "rainbowKey": "",
                          "enTooltip": "",
                          "cntooltip": ""
                        },
                        {
                          "value": "3",
                          "enName": "Refund Rate",
                          "cnName": "退款率",
                          "rainbowKey": "",
                          "disable": false,
                          "enTooltip": "",
                          "cntooltip": ""
                        },
                        {
                          "value": "4",
                          "enName": "Base Game Units After Refund",
                          "cnName": "本体销量(剔除退款)",
                          "rainbowKey": "",
                          "disable": false,
                          "enTooltip": "",
                          "cntooltip": ""
                        },
                        {
                          "value": "5",
                          "enName": "Revenue After Refund & Tax",
                          "cnName": "收入(剔除退款&税收)",
                          "rainbowKey": "",
                          "disable": false,
                          "enTooltip": "",
                          "cntooltip": ""
                        },
                        {
                          "value": "6",
                          "enName": "Revenue After Refund",
                          "cnName": "收入(剔除退款)",
                          "rainbowKey": "",
                          "disable": false,
                          "enTooltip": "",
                          "cntooltip": ""
                        }
                      ],
                      "scrollMarginTop": "75px"
                    }
                  },
                  "children": [
                    {
                      "name": "TrendChartCo",
                      "className": "",
                      "type": "view",
                      "props": {
                        "config": {
                          "preTitleIcon": "steam",
                          "title": "Realtime Daily Accum Gross Base Game Units (30Mins)",
                          "titleCn": "每日实时累计销量 (30分钟)",
                          "dataType": "int",
                          "dataKey": "dimension_sales",
                          "showDownloadModal": false,
                          "metricsCardList": {
                            "dataKey": "gross_full_game_units_info"
                          },
                          "lastTime": {
                            "dataKey": "gross_full_game_units_last_time"
                          },
                          "chart": {
                            "dataKey": "gross_full_game_units_top",
                            "tooltip": {
                              "title": "Gross Base Game Units",
                              "titleCn": "本体销量",
                              "share": true,
                              "shareTitle": "Share",
                              "shareTitleCn": "占比"
                            }
                          },
                          "table": {
                            "dataKey": "gross_full_game_units_list",
                            "options": [
                              {
                                "key": "time",
                                "align": "left",
                                "width": 100,
                                "title": "Time",
                                "titleCn": "时间",
                                "formatTitle": "realtime_by_country_table_time",
                                "type": "date",
                                "format": "HH:mm"
                              },
                              {
                                "key": "type",
                                "align": "left",
                                "width": 100,
                                "title": "table_{{dataBy}}",
                                "titleCn": "table_{{dataBy}}",
                                "formatTitle": "realtime_by_country_table_{{dataBy}}",
                                "type": "string"
                              },
                              {
                                "key": "value",
                                "align": "right",
                                "width": 100,
                                "title": "Gross Base Game Units",
                                "titleCn": "本体销量",
                                "type": "number",
                                "format": "#,##0"
                              },
                              {
                                "key": "share",
                                "align": "right",
                                "width": 100,
                                "title": "Share",
                                "titleCn": "占比",
                                "formatTitle": "",
                                "type": "number",
                                "format": "0.0%"
                              }
                            ]
                          }
                        }
                      }
                    },
                    {
                      "name": "TrendChartCo",
                      "className": "",
                      "type": "view",
                      "props": {
                        "config": {
                          "preTitleIcon": "steam",
                          "title": "Realtime Daily Accum Gross Revenue (30Mins)",
                          "titleCn": "每日实时累计收入 (30分钟)",
                          "dataKey": "dimension_sales",
                          "dataType": "money",
                          "formatRule": "thousands2Decimal",
                          "showDownloadModal": false,
                          "metricsCardList": {
                            "dataKey": "gross_revenue_info"
                          },
                          "lastTime": {
                            "dataKey": "gross_revenue_last_time"
                          },
                          "chart": {
                            "dataKey": "gross_revenue_top",
                            "tooltip": {
                              "title": "Gross Revenue",
                              "titleCn": "收入",
                              "share": true,
                              "shareTitle": "Share",
                              "shareTitleCn": "占比"
                            }
                          },
                          "table": {
                            "dataKey": "gross_revenue_list",
                            "options": [
                              {
                                "key": "time",
                                "align": "left",
                                "width": 100,
                                "title": "Time",
                                "titleCn": "时间",
                                "formatTitle": "realtime_by_country_table_time",
                                "type": "date",
                                "format": "HH:mm"
                              },
                              {
                                "key": "type",
                                "align": "left",
                                "width": 100,
                                "title": "table_{{dataBy}}",
                                "titleCn": "table_{{dataBy}}",
                                "formatTitle": "realtime_by_country_table_{{dataBy}}",
                                "type": "string"
                              },
                              {
                                "key": "value",
                                "align": "right",
                                "width": 100,
                                "title": "Gross Revenue",
                                "titleCn": "收入",
                                "type": "number",
                                "format": "#,##0.00"
                              },
                              {
                                "key": "share",
                                "align": "right",
                                "width": 100,
                                "title": "Share",
                                "titleCn": "占比",
                                "formatTitle": "",
                                "type": "number",
                                "format": "0.0%"
                              }
                            ]
                          }
                        }
                      }
                    },
                    {
                      "name": "TrendChartCo",
                      "className": "",
                      "type": "view",
                      "props": {
                        "config": {
                          "preTitleIcon": "steam",
                          "title": "Realtime Daily Accum Refund Rate (30Mins)",
                          "titleCn": "每日实时累计退款率 (30分钟)",
                          "dataKey": "dimension_sales",
                          "showDownloadModal": false,
                          "metricsCardList": {
                            "dataKey": "refund_rate_info"
                          },
                          "lastTime": {
                            "dataKey": "refund_rate_last_time"
                          },
                          "chart": {
                            "dataKey": "refund_rate_top",
                            "tooltip": {
                              "title": "Refund Rate",
                              "titleCn": "退款率"
                            }
                          },
                          "table": {
                            "dataKey": "refund_rate_list",
                            "options": [
                              {
                                "key": "time",
                                "align": "left",
                                "width": 100,
                                "title": "Time",
                                "titleCn": "时间",
                                "formatTitle": "realtime_by_country_table_time",
                                "type": "date",
                                "format": "HH:mm"
                              },
                              {
                                "key": "type",
                                "align": "left",
                                "width": 100,
                                "title": "table_{{dataBy}}",
                                "titleCn": "table_{{dataBy}}",
                                "formatTitle": "realtime_by_country_table_{{dataBy}}",
                                "type": "string"
                              },
                              {
                                "key": "value",
                                "align": "right",
                                "width": 100,
                                "title": "Refund Rate",
                                "titleCn": "退款率",
                                "type": "number",
                                "format": "0.00%"
                              }
                            ]
                          }
                        }
                      }
                    },
                    {
                      "name": "TrendChartCo",
                      "className": "",
                      "type": "view",
                      "props": {
                        "config": {
                          "preTitleIcon": "steam",
                          "title": "Realtime Daily Accum Base Game Units After Refund (30Mins)",
                          "titleCn": "每日实时累计销量(剔除退款) (30分钟)",
                          "dataType": "int",
                          "dataKey": "dimension_sales",
                          "showDownloadModal": false,
                          "metricsCardList": {
                            "dataKey": "net_full_game_units_info"
                          },
                          "lastTime": {
                            "dataKey": "net_full_game_units_last_time"
                          },
                          "chart": {
                            "dataKey": "net_full_game_units_top",
                            "tooltip": {
                              "title": "Base Game Units After Refund",
                              "titleCn": "本体销量(剔除退款)",
                              "share": true,
                              "shareTitle": "Share",
                              "shareTitleCn": "占比"
                            }
                          },
                          "table": {
                            "dataKey": "net_full_game_units_list",
                            "options": [
                              {
                                "key": "time",
                                "align": "left",
                                "width": 100,
                                "title": "Time",
                                "titleCn": "时间",
                                "formatTitle": "realtime_by_country_table_time",
                                "type": "date",
                                "format": "HH:mm"
                              },
                              {
                                "key": "type",
                                "align": "left",
                                "width": 100,
                                "title": "table_{{dataBy}}",
                                "titleCn": "table_{{dataBy}}",
                                "formatTitle": "realtime_by_country_table_{{dataBy}}",
                                "type": "string"
                              },
                              {
                                "key": "value",
                                "align": "right",
                                "width": 100,
                                "title": "Base Game Units After Refund",
                                "titleCn": "本体销量(剔除退款)",
                                "type": "number",
                                "format": "#,##0"
                              },
                              {
                                "key": "share",
                                "align": "right",
                                "width": 100,
                                "title": "Share",
                                "titleCn": "占比",
                                "formatTitle": "",
                                "type": "number",
                                "format": "0.0%"
                              }
                            ]
                          }
                        }
                      }
                    },
                    {
                      "name": "TrendChartCo",
                      "className": "",
                      "type": "view",
                      "props": {
                        "config": {
                          "preTitleIcon": "steam",
                          "title": "Realtime Daily Accum Revenue After Refund & Tax (30Mins)",
                          "titleCn": "每日实时累计收入(剔除退款&税收) (30分钟)",
                          "dataKey": "dimension_sales",
                          "dataType": "money",
                          "formatRule": "thousands2Decimal",
                          "showDownloadModal": false,
                          "metricsCardList": {
                            "dataKey": "net_revenue_info"
                          },
                          "lastTime": {
                            "dataKey": "net_revenue_last_time"
                          },
                          "chart": {
                            "dataKey": "net_revenue_top",
                            "tooltip": {
                              "title": "Revenue After Refund & Tax",
                              "titleCn": "收入(剔除退款&税收)",
                              "share": true,
                              "shareTitle": "Share",
                              "shareTitleCn": "占比"
                            }
                          },
                          "table": {
                            "dataKey": "net_revenue_list",
                            "options": [
                              {
                                "key": "time",
                                "align": "left",
                                "width": 100,
                                "title": "Time",
                                "titleCn": "时间",
                                "formatTitle": "realtime_by_country_table_time",
                                "type": "date",
                                "format": "HH:mm"
                              },
                              {
                                "key": "type",
                                "align": "left",
                                "width": 100,
                                "title": "table_{{dataBy}}",
                                "titleCn": "table_{{dataBy}}",
                                "formatTitle": "realtime_by_country_table_{{dataBy}}",
                                "type": "string"
                              },
                              {
                                "key": "value",
                                "align": "right",
                                "width": 100,
                                "title": "Revenue After Refund & Tax",
                                "titleCn": "收入(剔除退款&税收)",
                                "type": "number",
                                "format": "#,##0.00"
                              },
                              {
                                "key": "share",
                                "align": "right",
                                "width": 100,
                                "title": "Share",
                                "titleCn": "占比",
                                "formatTitle": "",
                                "type": "number",
                                "format": "0.0%"
                              }
                            ]
                          }
                        }
                      }
                    },
                    {
                      "name": "TrendChartCo",
                      "className": "",
                      "type": "view",
                      "props": {
                        "config": {
                          "preTitleIcon": "steam",
                          "title": "Realtime Daily Accum Revenue After Refund (30Mins)",
                          "titleCn": "每日实时累计收入(剔除退款) (30分钟)",
                          "dataKey": "dimension_sales",
                          "dataType": "money",
                          "formatRule": "thousands2Decimal",
                          "showDownloadModal": false,
                          "metricsCardList": {
                            "dataKey": "gross_refund_after_revenue_info"
                          },
                          "lastTime": {
                            "dataKey": "gross_refund_after_revenue_last_time"
                          },
                          "chart": {
                            "dataKey": "gross_refund_after_revenue_top",
                            "tooltip": {
                              "title": "Revenue After Refund",
                              "titleCn": "收入(剔除退款)",
                              "share": true,
                              "shareTitle": "Share",
                              "shareTitleCn": "占比"
                            }
                          },
                          "table": {
                            "dataKey": "gross_refund_after_revenue_list",
                            "options": [
                              {
                                "key": "time",
                                "align": "left",
                                "width": 100,
                                "title": "Time",
                                "titleCn": "时间",
                                "formatTitle": "realtime_by_country_table_time",
                                "type": "date",
                                "format": "HH:mm"
                              },
                              {
                                "key": "type",
                                "align": "left",
                                "width": 100,
                                "title": "table_{{dataBy}}",
                                "titleCn": "table_{{dataBy}}",
                                "formatTitle": "realtime_by_country_table_{{dataBy}}",
                                "type": "string"
                              },
                              {
                                "key": "value",
                                "align": "right",
                                "width": 100,
                                "title": "Revenue After Refund",
                                "titleCn": "收入(剔除退款)",
                                "type": "number",
                                "format": "#,##0.00"
                              },
                              {
                                "key": "share",
                                "align": "right",
                                "width": 100,
                                "title": "Share",
                                "titleCn": "占比",
                                "formatTitle": "",
                                "type": "number",
                                "format": "0.0%"
                              }
                            ]
                          }
                        }
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};